import loaderCss from "./Loader.module.css";

const Loader = () => (
  <div className={loaderCss.loaderContainer}>
    <div className={loaderCss.loaderAnime}></div>
    <div className={loaderCss.loaderAnimeDelayed}></div>
  </div>
);

export default Loader;
